import React, { ComponentProps, FC } from "react"

import WpGraphqlSeo from "gatsby-plugin-wpgraphql-seo"

type SeoProps = ComponentProps<typeof WpGraphqlSeo>

const BLOG_CANONICAL_URL =
  process.env.GATSBY_BLOG_CANONICAL_URL ?? "https://avantstay.com/blog"

const TEMPORARY_NAME_FOR_REPLACE = "REPLACE_FOR_CONTENT"

const wordPress = {
  blogContentUrl: "https://blogwp.prod.avantstay.com/wp-content",
  blogUrl: "https://blogwp.prod.avantstay.com",
  serverIpRegExp: /https:\/\/\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}:443/g,
}

export const Seo: FC<SeoProps> = ({ post, ...restProps }) => {
  const postWithCorrectSchemaDomains = (() => {
    const seo = post?.seo
    if (!seo) return post

    const { schema } = seo
    const { raw } = schema

    // Part of the schema has the IP Address of WordPress server on it
    // Currently I don't know how to replace the IP for domain in WordPress
    const rawReplaced = raw
      ?.replaceAll(wordPress.serverIpRegExp, BLOG_CANONICAL_URL)
      .replaceAll(wordPress.blogContentUrl, TEMPORARY_NAME_FOR_REPLACE)
      .replaceAll(wordPress.blogUrl, BLOG_CANONICAL_URL)
      .replaceAll(TEMPORARY_NAME_FOR_REPLACE, wordPress.blogContentUrl)

    return {
      ...post,
      seo: { ...seo, schema: { ...schema, raw: rawReplaced } },
    }
  })()

  return <WpGraphqlSeo post={postWithCorrectSchemaDomains} {...restProps} />
}
